import { Component } from '@angular/core';

import { type CardData, HoverExpandableCardsComponent } from '@shared/components';

@Component({
  selector: 'app-scene-showcase',
  templateUrl: './scene-showcase.html',
  styleUrl: './scene-showcase.scss',
  imports: [HoverExpandableCardsComponent],
})
export class SceneShowcase {
  readonly expandableCards: CardData[] = [
    {
      video: '',
      poster: 'assets/demo/old-man.png',
      title: 'Before',
      description: '2D flat image',
    },
    {
      video: 'assets/demo/old-man-evrn-layout-ref.webm',
      title: 'After',
      description: '3D with every asset separated',
    },
  ];
}
